module.exports = __webpack_public_path__ + "static/media/header.96d0d2e9.mp3";